export default [
  {
    path: "/company/index",
    name: "Companies-list",
    component: () => import("@/views/Company/Index.vue"),
    meta: {
      resource: "Companies",
      action: "View",
    },
  },
  {
    path: "/company/add",
    name: "company-add",
    component: () => import("@/views/Company/Add.vue"),
    meta: {
      resource: "Companies",
      action: "Save",
    },
  },
  {
    path: "/company/edit/:id/:name",
    name: "company-edit",
    component: () => import("@/views/Company/Edit.vue"),
    meta: {
      resource: "Companies",
      action: "Update",
    },
  },
  {
    path: "/merchants",
    name: "Merchants-list",
    component: () => import("@/views/merchants/merchants.vue"),
    meta: {
      resource: "Merchants",
      action: "View",
    },
  },
  {
    path: "/merchants/add",
    name: "merchants-add",
    component: () => import("@/views/merchants/Add.vue"),
    meta: {
      resource: "Merchants",
      action: "Save",
    },
  },
  {
    path: "/merchants/:id",
    name: "merchants-edit",
    component: () => import("@/views/merchants/Edit.vue"),
    meta: {
      resource: "Merchants",
      action: "Update",
    },
  },
  {
    path: "/merchants/:id/details",
    name: "merchants-detail",
    component: () => import("@/views/merchants/Details.vue"),
    meta: {
      resource: "Merchants",
      action: "View",
    },
  },
  {
    path: "/hostingpagemerchants",
    name: "MerchantsHostingPage-list",
    component: () => import("@/views/merchants/hostingPage/index.vue"),
    meta: {
      resource: "MerchantsHostingPage",
      action: "View",
    },
  },
  {
    path: "/hostingpagemerchants/add",
    name: "MerchantsHostingPage-add",
    component: () => import("@/views/merchants/hostingPage/Add.vue"),
    meta: {
      resource: "MerchantsHostingPage",
      action: "Save",
    },
  },
  {
    path: "/hostingpagemerchants/edit/:id",
    name: "MerchantsHostingPage-edit",
    component: () => import("@/views/merchants/hostingPage/Edit.vue"),
    meta: {
      resource: "MerchantsHostingPage",
      action: "Update",
    },
  },
  {
    path: "/hostingpagemerchants/:id/details",
    name: "MerchantsHostingPage-detail",
    component: () => import("@/views/merchants/hostingPage/Details.vue"),
    props: true,
    meta: {
      resource: "MerchantsHostingPage",
      action: "View",
    },
  },
];
